import React from "react";

import { Field, FieldLabel, ValidationError } from "affinityUI/form/components";
import { Textarea } from "affinityUI/form/inputs/textarea";

import { useAffinityField } from "../../helpers";

export const TextareaField: React.FC<React.ComponentProps<typeof Textarea>> = ({ children, ...props }) => {
  const { name } = props;
  const [fieldData, meta] = useAffinityField(name);
  const field = { ...fieldData, value: fieldData.value ?? "" };
  return (
    <Field>
      <FieldLabel id={`field-${name}`} htmlFor={name}>
        {children}
      </FieldLabel>
      <Textarea id={name} $error={meta?.error} {...field} {...props} />
      {meta?.error && <ValidationError>{meta?.error}</ValidationError>}
    </Field>
  );
};
